<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="company-profile-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button
          type="primary"
          icon="el-icon-back"
          class="back-button"
          @click.prevent="goBack">
        </el-button>
        <h2 class="page-title">{{ isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'เพิ่มรายการผู้ชำระใหม่' }}</h2>
      </el-col>
    </el-row>

    <el-form
      v-if="profile"
      :model="payerForm"
      :rules="payerFormRules"
      ref="payerForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('payerForm')"
      :disabled="isSubmitting"
      class="slip-form profile-detail-info detail-form company-detail-info">
      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">{{ isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'เพิ่มรายการผู้ชำระ' }}สำหรับ {{ profile.name }}</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="ชื่อผู้ชำระ" prop="payer.name">
                <el-input
                  v-model="payerForm.payer.name"
                  id="payerForm.payer.name"
                  :autofocus="true"
                  :maxlength="40"
                  placeholder="กรอกชื่อผู้ชำระ"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item label="อีเมลผู้ชำระสำหรับส่งใบ pay-in/qr code ทางอีเมล" prop="payer.email">
                <el-input
                  v-model="payerForm.payer.email"
                  id="payerForm.payer.email"
                  placeholder="กรอกอีเมลผู้ชำระ"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">รายละเอียดการชำระ</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="วันที่ครบกำหนดชำระ" prop="issued_on">
                <el-date-picker
                  type="date"
                  prefix-icon=""
                  v-model="payerForm.issued_on"
                  id="payerForm.issued_on"
                  placeholder="กรอกวันที่ครบกำหนดชำระ"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="ref1Label" prop="ref1">
                <el-input
                  v-model="payerForm.ref1"
                  id="payerForm.ref1"
                  @change="updateMaskRefCode"
                  ref="payerForm.ref1"
                  :maxlength="20"
                  @input.native="handleInput($event, 'payerForm.ref1', 'refCode')"
                  :placeholder="`กรอก${ref1Label}`"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="1">
              <el-form-item :label="ref2Label" prop="ref2">
                <el-input
                  v-model="payerForm.ref2"
                  id="payerForm.ref2"
                  ref="payerForm.ref2"
                  :maxlength="20"
                  @change="updateMaskRefCode"
                  @input.native="handleInput($event, 'payerForm.ref2', 'refCode')"
                  :placeholder="`กรอก${ref2Label}`"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="10">
              <el-form-item label="จำนวนที่ต้องชำระ (บาท)" prop="amount">
                <el-input
                  v-model="payerForm.amount"
                  id="payerForm.amount"
                  @change="updateMaskAmount"
                  ref="payerForm.amount"
                  @input.native="handleInput($event, 'payerForm.amount', 'amountMask')"
                  placeholder="กรอกจำนวนที่ต้องชำระ"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">การแจ้งเตือน</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="21">
              <el-checkbox
                @change="toggleUseSCBNotiMsg"
                v-model="useDefaultSCBNoti">ใช้การแจ้งเตือนจาก Admin ของบริษัท</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="21" class="notification-block">
              <el-form-item
                label=""
                ref="notification_msg"
                prop="notification_msg">
                <el-row>
                  <el-col :span="24">
                    <el-radio
                      v-model="payerForm.notification_msg_type"
                      :disabled="useDefaultSCBNoti"
                      label="DATE"
                      @change="toggleUsingNotificationMsgValue"
                      id="payerForm.notification_msg_type_1">
                      <el-row>
                        <el-col :span="8">กรุณาชำระภายในวันที่</el-col>
                        <el-col :span="5" :offset="1">
                          <el-select
                            v-model="payerForm.notification_msg_date"
                            :disabled="payerForm.notification_msg_type === 'CUSTOM' || useDefaultSCBNoti"
                            @change="toggleUsingNotificationMsgValue"
                            style="width:100px;text-align:center;"
                            id="payerForm.notification_msg_date">
                            <el-option
                              v-for="day in notificationDayList"
                              :key="day"
                              :label="day"
                              :value="day">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="5" :offset="1">
                          ของทุกเดือน
                        </el-col>
                      </el-row>
                    </el-radio>
                  </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                  <el-col :span="24">
                    <el-radio
                      v-model="payerForm.notification_msg_type"
                      label="CUSTOM"
                      :disabled="useDefaultSCBNoti"
                      @change="toggleUsingNotificationMsgValue"
                      id="payerForm.notification_msg_type_2">
                    </el-radio>
                    <el-input
                      v-model="payerForm.notification_msg_custom"
                      :disabled="payerForm.notification_msg_type !== 'CUSTOM' || useDefaultSCBNoti"
                      id="payerForm.notification_msg_custom"
                      :maxlength="100"
                      style="width:300px;"
                      placeholder="กรอกข้อความแจ้งเตือนที่ต้องการ"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="21">
              <el-form-item label="Remark" prop="remark">
                <el-input
                  v-model="payerForm.remark"
                  id="payerForm.remark"
                  :maxlength="100"
                  placeholder="กรอกข้อความที่นี่"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
      <el-row>
        <el-col :span="21">
          <el-form-item class="button-bar">
            <el-button
              type="primary"
              plain
              class="cancel-btn"
              @click="goBack"
              id="adminForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
            <div class="submit-button-group">
              <el-button
                type="danger"
                class="terminate-btn"
                icon="el-icon-delete"
                v-if="isUpdated && isBillerAdmin"
                @click="confirmTerminate"
                id="adminForm.terminateButton">{{ 'Terminate' | translate }}</el-button>
              <el-button
                type="primary"
                id="adminForm.submitButton"
                icon="el-icon-edit"
                native-type="submit">{{ isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'สร้างรายการผู้ชำระใหม่' }}</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  import numeral from 'numeral';
  import moment from 'moment-timezone';
  import { createMask, MaskedNumber } from 'imask';
  import helpers from '@/libs/helpers';
  import _ from 'lodash';

  const BillerSlipFormView = {
    name: 'biller-profile-form',
    props: ['profileId', 'slipId'],
    data() {
      return {
        isSubmitting: false,
        isSetupUpdateData: false,
        useDefaultSCBNoti: true,
        dayList: [],
        payerForm: {
          payer: {
            name: '',
            email: '',
          },
          issued_on: '',
          amount: '',
          ref1: '',
          ref2: '',
          ref3: '',
          remark: '',
          is_sent: false,
          is_printed: false,
          notification_msg_type: 'CUSTOM', // DATE or CUSTOM
          notification_msg_date: '1',
          notification_msg_custom: '',
          notification_msg: '',
        },
        payerFormRules: {
          'payer.name': [
            { required: true, max: 40, message: 'กรุณากรอกชื่อผู้ชำระ', trigger: 'blur' },
          ],
          'payer.email': [
            // { required: true, message: 'กรุณากรอกอีเมลผู้ชำระ', trigger: 'blur' },
            { type: 'email', message: 'กรุณากรอกอีเมลผู้ชำระให้ถูกต้อง', trigger: 'blur' },
          ],
          issued_on: [
            { required: true, message: 'กรุณาเลือกวันที่ครบกำหนดชำระ', trigger: 'blur' },
            // { type: 'date', message: 'กรุณาเลือกวันที่ออกเอกสารให้ถูกต้อง', trigger: 'blur' },
          ],
          amount: [
            { required: true, message: 'กรุณากรอกจำนวนที่ต้องชำระ', trigger: 'blur' },
            {
              validator: this.validateAmount,
              message: 'กรุณากรอกจำนวนที่ต้องชำระไม่เกิน 100 ล้านบาท',
              trigger: 'blur',
            },
          ],
          ref1: [
            { type: 'string', required: true, max: 20, message: 'กรุณากรอก Ref. 1', trigger: 'blur' },
          ],
          ref2: [
            { type: 'string', max: 20, message: 'กรุณากรอก Ref. 2', trigger: 'blur' },
          ],
          notification_msg: [
            { validator: this.checkNotificationMsg, max: 100, message: 'กรุณากรอกข้อความแจ้งเตือน', trigger: 'blur' },
          ],
        },
        mask: {
          amountMask: {
            mask: MaskedNumber,
            scale: 2,
            signed: false,
            thousandsSeparator: ',',
            padFractionalZeros: true,
            normalizeZeros: true,
            radix: '.',
            mapToRadix: ['.'],
            max: 99999999.99,
          },
          refCode: {
            mask: /^[0-9A-Z]{0,20}$/,
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isUpdated() {
        return typeof this.slipId !== 'undefined';
      },
      isBillerAdmin() {
        if (this.$store.getters.myAdminInfo) {
          return this.$store.getters.myAdminInfo.role === 'ADMIN';
        }
        return false;
      },
      profile() {
        return this.$store.getters.currentBillerProfile;
      },
      slip() {
        return this.$store.getters.currentBillerSlip;
      },
      ref1Label() {
        if (this.profile) {
          return `${this.profile.label_ref1} (Reference No. 1)`;
        }
        return '';
      },
      ref2Label() {
        if (this.profile) {
          return `${this.profile.label_ref2} (Reference No. 2)`;
        }
        return '';
      },
      ref1ErrorMessage() {
        return `กรุณากรอก${this.ref1Label}`;
      },
      ref2ErrorMessage() {
        return `กรุณากรอก${this.ref2Label}`;
      },
      notificationDayList() {
        return this.dayList;
      },
    },
    methods: {
      goBack() {
        this.$router.push({
          name: 'BillerProfileDetail',
          params: {
            profileId: this.profileId,
          },
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate(this.validateForm);
      },
      validateForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        // build payload first
        this.updateNotificationMsgValue();
        this.isSubmitting = true;
        const payload = JSON.parse(JSON.stringify(this.payerForm));
        // adjust format for date & amount
        payload.issued_on = moment(payload.issued_on).format('YYYY-MM-DD');
        // payload.amount = numeral(payload.amount).value();
        this.unmaskValue(payload, 'amount', this.mask.amountMask);
        const action = this.isUpdated ? 'UPDATE_BILLER_SLIP_INFO' : 'CREATE_BILLER_SLIP_INFO';
        const reqPayload = {
          payload,
        };
        if (this.isUpdated) {
          reqPayload.slipId = payload.id;
        } else {
          reqPayload.profileId = this.profileId;
        }
        this.$store.dispatch(action, reqPayload).then(() => {
          this.isSubmitting = false;
          let successMessage = 'สร้างรายการผู้ชำระเงินใหม่สำเร็จแล้ว';
          if (this.isUpdated) {
            successMessage = 'แก้ไขรายการผู้ชำระเงินสำเร็จแล้ว';
          }
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: successMessage,
          });
          this.$nextTick(() => {
            this.goBack();
          });
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            let errMessage = msg;
            if (typeof msg === 'object') {
              const errorObjects = [];
              Object.keys(msg).forEach((key) => {
                errorObjects.push(`${key}: ${msg[key]}`);
              });
              errMessage = errorObjects.join(', ');
            }
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMessage));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      confirmTerminate() {
        this.$confirm('ท่านกำลังจะลบรายการผู้ชำระนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
          confirmButtonText: this.$t('Confirm'),
          confirmButtonClass: 'danger-btn',
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.isSubmitting = true;
          this.$store.dispatch('DELETE_BILLER_SLIP_INFO', this.slipId).then(() => {
            this.isSubmitting = false;
            this.$message({
              type: 'success',
              showClose: true,
              duration: 10000,
              message: 'ลบรายการผู้ชำระสำเร็จแล้ว',
            });
            this.goBack();
          }).catch((msg) => {
            this.isSubmitting = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
          });
        }).catch(() => {
        });
      },
      validateAmount(rule, value, cb) {
        this.updateMaskAmount();
        const num = numeral(this.payerForm.amount);
        if (num.value() > 99999999.99) {
          cb(new Error('Amount must more than 0'));
        } else {
          cb();
        }
      },
      setupUpdateData() {
        this.isSetupUpdateData = true;
        Object.keys(this.slip).forEach((key) => {
          if (key === 'payer') {
            Object.keys(this.slip.payer).forEach((payerKey) => {
              this.$set(this.payerForm.payer, payerKey, this.slip.payer[payerKey]);
            });
          } else if (key === 'issued_on') {
            const issuedOn = moment(this.slip[key]).tz(process.env.DEFAULT_TZ);
            if (issuedOn.isValid()) {
              this.$set(this.payerForm, key, issuedOn.toDate());
            } else {
              this.$set(this.payerForm, key, this.slip[key]);
            }
          } else if (key === 'notification_msg') {
            if (this.slip[key] === null) {
              this.useDefaultSCBNoti = true;
              if (this.profile && this.profile.notification_msg) {
                this.$set(this.payerForm, key, this.profile.notification_msg);
              }
            } else {
              this.$set(this.payerForm, key, this.slip[key]);
            }
          } else {
            this.$set(this.payerForm, key, this.slip[key]);
          }
        });
        if (this.profile &&
          ((this.profile.notification_msg === this.payerForm.notification_msg) ||
          (this.profile.notification_msg === null && this.payerForm.notification_msg === ''))) {
          this.useDefaultSCBNoti = true;
        } else {
          this.useDefaultSCBNoti = false;
        }
        if (this.payerForm.notification_msg === null) {
          this.payerForm.notification_msg = '';
        }
        this.checkNotiMessageType();
        this.$nextTick(() => {
          // update mask stuffs
          this.updateMaskAmount();
          this.updateMaskRefCode();
        });
      },
      clearUpdateData() {
        this.isSetupUpdateData = false;
        Object.keys(this.payerForm).forEach((key) => {
          if (key === 'payer') {
            Object.keys(this.payerForm.payer).forEach((payerKey) => {
              this.$set(this.payerForm.payer, payerKey, '');
            });
          } else {
            this.$set(this.payerForm, key, '');
          }
        });
      },
      checkNotificationMsg(rule, value, cb) {
        // check if custom message is select and not blank
        this.updateNotificationMsgValue();
        cb();
      },
      toggleUseSCBNotiMsg() {
        if (!this.isUpdated && this.profile) {
          if (this.profile.notification_msg) {
            this.payerForm.notification_msg = this.profile.notification_msg;
          } else {
            this.payerForm.notification_msg = '';
          }
        }
        if (this.useDefaultSCBNoti) {
          this.payerForm.notification_msg_type = '';
          // get data from profile
          if (this.profile) {
            if (this.profile.notification_msg) {
              this.payerForm.notification_msg = this.profile.notification_msg;
            } else {
              this.payerForm.notification_msg = '';
            }
          }
        } else {
          this.payerForm.notification_msg_type = this.payerForm
            .notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 &&
          this.payerForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
          if (this.payerForm.notification_msg_type === 'DATE') {
            this.payerForm
              .notification_msg_date = this.payerForm.notification_msg
                .replace('กรุณาชำระภายในวันที่', '')
                .replace('ของทุกเดือน', '');
          } else {
            this.payerForm.notification_msg_custom = this.payerForm.notification_msg;
          }
        }
      },
      updateNotificationMsgValue() {
        if (this.payerForm.notification_msg_type === 'CUSTOM') {
          this.payerForm.notification_msg = this.payerForm.notification_msg_custom;
        } else if (this.payerForm.notification_msg_type === 'DATE') {
          this.payerForm.notification_msg = `กรุณาชำระภายในวันที่ ${this.payerForm.notification_msg_date} ของทุกเดือน`;
        }
      },
      checkNotiMessageType() {
        if (this.useDefaultSCBNoti) {
          this.payerForm.notification_msg_type = '';
          // get data from profile
          if (this.profile) {
            if (this.profile.notification_msg) {
              this.payerForm.notification_msg = this.profile.notification_msg;
            } else {
              this.payerForm.notification_msg = '';
            }
          }
        } else {
          this.payerForm.notification_msg_type = this.payerForm
            .notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 &&
            this.payerForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
          if (this.payerForm.notification_msg_type === 'DATE') {
            this.payerForm
              .notification_msg_date = this.payerForm.notification_msg
                .replace('กรุณาชำระภายในวันที่', '')
                .replace('ของทุกเดือน', '');
          } else {
            this.payerForm.notification_msg_custom = this.payerForm.notification_msg;
          }
        }
      },
      toggleUsingNotificationMsgValue() {
        if (this.payerForm.notification_msg_type === 'DATE') {
          this.payerForm.notification_msg_custom = '';
        }
        this.$refs.payerForm.validateField('notification_msg');
      },
      updateMaskAmount() {
        this.maskValue(this.payerForm, 'amount', this.mask.amountMask);
      },
      updateMaskRefCode() {
        this.payerForm.ref1 = this.payerForm.ref1.toUpperCase();
        this.payerForm.ref2 = this.payerForm.ref2.toUpperCase();
        this.maskValue(this.payerForm, 'ref1', this.mask.refCode);
        this.maskValue(this.payerForm, 'ref2', this.mask.refCode);
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        if (['payerForm.ref1', 'payerForm.ref2'].indexOf(refName) !== -1) {
          this.payerForm.ref1 = this.payerForm.ref1.toUpperCase();
          this.payerForm.ref2 = this.payerForm.ref2.toUpperCase();
        }
        this.$nextTick(() => {
          helpers.handleInput(evt,
            this.$refs, refName,
            this.mask, maskName);
        });
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
    },
    mounted() {
      this.clearUpdateData();
      const now = moment().tz(process.env.DEFAULT_TZ);
      // default date is today
      this.payerForm.issued_on = now.toDate();
      if (this.isUpdated) {
        setTimeout(() => {
          if (typeof this.slip === 'undefined' || this.slip === null) {
            this.goBack();
          }
        }, 1000);
      }
      // clear list
      this.dayList.splice(0);
      // populate day list
      for (let d = 1; d <= 31; d += 1) {
        this.dayList.push(d);
      }
      if (this.isUpdated && this.slip) {
        this.setupUpdateData();
      } else if (!this.isUpdated && this.profile) {
        if (this.profile.notification_msg) {
          this.payerForm.notification_msg = this.profile.notification_msg;
        } else {
          this.payerForm.notification_msg = '';
        }
      }
    },
    watch: {
      slip(newVal) {
        if (!this.isSetupUpdateData && this.isUpdated && newVal) {
          this.setupUpdateData();
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', vm.profileId);
        vm.$store.dispatch('SELECT_CURRENT_BILLER_SLIP', vm.slipId);
      });
    },
    beforeRouteLeave(to, from, next) {
      // clear current selection
      this.clearUpdateData();
      this.$store.dispatch('SELECT_CURRENT_BILLER_SLIP', '');
      next();
    },
  };
  export default BillerSlipFormView;
</script>

<style lang="scss">
  .slip-form {
    .cancel-btn, .terminate-btn {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .submit-button-group {
      float: right;
    }
    .el-date-editor {
      width: 100%;
    }
    .notification-block {
      border: 1px solid #ccc;
      background-color: #fefefe;
      border-radius: 4px;
      padding: 10px 20px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    #payerForm\.notification_msg_type_1 .el-radio__input {
      display: inline-block;
      line-height: 50px;
      float: left;
    }
    #payerForm\.notification_msg_type_1 .el-radio__label {
      display: block;
      width: 500px;
      line-height: 50px;
      margin-left: 15px;
    }
    #payerForm\.notification_msg_type_2 .el-radio__label {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/biller/slip-form.vue